module.exports = __webpack_public_path__ + "static/media/29110023-KLSzwSgs.dad601ad.JPG";